import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import gdsclogo from "./gdsclogo.png";

function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top">
            <div className="container-fluid">
                <Link to="/" className="nav-logo">
                    <span className="navbar-brand">
                        <img src={gdsclogo} alt="gdsclogo" />
                    </span>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup" style={{ justifyContent: "flex-end" }}>
                    <div className="navbar-nav">
                        <Link to="./our-vision" className="nav-link">
                            Vision
                        </Link>
                        <Link to="./aboutus" className="nav-link">
                            About
                        </Link>
                        <Link to="./our-team" className="nav-link">
                            Team
                        </Link>
                        <Link to="./events" className="nav-link">
                            Events
                        </Link>
                        <Link to="./projects" className="nav-link">
                            Projects
                        </Link>
                        <Link to="./explore-more" className="nav-link">
                            Explore More
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;